// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__th63o","active":"styles_active__2-lKy","inactive":"styles_inactive__3s6DB"};